import React from 'react';
import { CurrencyUtils, SharedUtils, TranslationUtils } from '../../utils';
import './ReceiptMor.scss';
import { ReceiptLineSummary, ReceiptTotalTitle } from '../../components';
import { useSelector } from 'react-redux';
import { StoreState } from '../../types/store.type';
import { CookieKeys } from '../../types/keys.type';
import { Currency } from '../../types/preference.type';

interface ReceiptDetailsProps {
    locale: string;
}

export const ReceiptDetails: React.FC<ReceiptDetailsProps> = (props) => {
    const { trip } = useSelector((store: StoreState) => store);
    const { reservation } = trip;
    let currency = SharedUtils.getCookie(CookieKeys.PREFERRED_CURRENCY) as any;
    currency = currency || Currency.USD;
    if (!reservation) {
        return null;
    }
    const { locale } = props;
    const shouldShowPreviousBalance = reservation.balance > 0;

    return (
        <div className={'p-2 price-detail-block'}>
            <div tabIndex={0}>
                <h3 className={'sr-only'}>{TranslationUtils.get('payment_form_pricing_details')}</h3>
            </div>
            <h4 className={'p-2 muted type-body-small font-weight-bold price-breakdown-header text-uppercase'} />
            {shouldShowPreviousBalance && (
                <>
                    {
                        <ReceiptLineSummary
                            summaryTitle={TranslationUtils.get('previous_balance')}
                            summaryValue={CurrencyUtils.formatCurrency(reservation.balance, reservation.booked_currency_code || currency)}
                            currency={reservation.booked_currency_code || ''}
                            locale={locale}
                        />
                    }
                    <hr className={'detail-separator'} />
                </>
            )}
            <ReceiptTotalTitle
                summary={{
                    total: reservation.balance,
                    currency: reservation.booked_currency_code || '',
                }}
                convertedSummary={{
                    total: reservation.converted_amount?.balance || 0,
                    currency: reservation.converted_amount?.currency || currency,
                    conversion_rate: reservation.converted_amount?.conversion_rate,
                }}
                locale={locale}
            />
        </div>
    );
};
